import { useEffect, useState } from "react";
import { PortalColaboradorService } from "services/PortalColaboradorService";

const useObtenerOtroAprobadorPrimerNivel = () => {
	const [otroAprobadorPrimerFlujo, setOtroAprobadorPrimerFlujo] = useState(undefined);
	useEffect(() => {
		const cargarDatos = async () => {
			const otroAprobadorPrimerFLujo = await PortalColaboradorService.obtenerOtroAprobadorPrimerFlujo();
			console.log("otroAprobadorPrimerFLujo", otroAprobadorPrimerFLujo);
			setOtroAprobadorPrimerFlujo(otroAprobadorPrimerFLujo);
		};
		cargarDatos();
	}, []);
	return { otroAprobadorPrimerFlujo };
};

export default useObtenerOtroAprobadorPrimerNivel;
